var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaskTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.08837 11.5561C7.11519 12.0433 5.98985 12.2521 4.83018 12.0929C1.77186 11.6732 -0.367144 8.8537 0.0525794 5.79539C0.472303 2.73707 3.29181 0.598066 6.35013 1.01779C9.40844 1.43751 11.5474 4.25702 11.1277 7.31534C11.0311 8.0194 10.8073 8.67474 10.4827 9.26136C10.6177 9.30641 10.745 9.381 10.8544 9.48493L16.395 14.7485C16.6297 14.9715 16.742 15.2944 16.6962 15.6149L16.5464 16.6631C16.4836 17.1031 16.1379 17.4487 15.6979 17.5116L14.6338 17.6636C14.3222 17.7081 14.0078 17.6033 13.7853 17.3808L13.4453 17.0408C13.2578 16.8533 13.0034 16.748 12.7382 16.748H12.1797C11.6274 16.748 11.1797 16.3002 11.1797 15.748V15.6425C11.1797 15.1448 10.8137 14.7229 10.3211 14.6525L9.73671 14.5691C9.24406 14.4987 8.87813 14.0768 8.87813 13.5791V12.8879C8.87813 12.6226 8.77277 12.3683 8.58523 12.1808L8.31877 11.9143C8.21351 11.809 8.13682 11.6865 8.08837 11.5561ZM5.44324 5.20769C5.31979 6.1072 4.49052 6.73631 3.59102 6.61287C2.69151 6.48942 2.06239 5.66015 2.18584 4.76065C2.30929 3.86114 3.13856 3.23202 4.03806 3.35547C4.93757 3.47892 5.56669 4.30819 5.44324 5.20769Z",
    fill: "#01E69C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskTag);
export default __webpack_public_path__ + "static/media/taskTag.d5f6109fc133f608c617be8221f44686.svg";
export { ForwardRef as ReactComponent };